import m from './1.0.0/index.js'

export default m;
